// extracted by mini-css-extract-plugin
export default {"variableIconWrapper":"WhiteLabeling_variableIconWrapper__HE-zo","footerAlign":"WhiteLabeling_footerAlign__4tcnm"};